import React from 'react'
import classnames from 'classnames'

interface ModalMessageIconProps {
  className?: string
}

const ModalMessageErrorIcon: React.FC<ModalMessageIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      className={classnames('icon--modal-message-error', {
        [className]: !!className,
      })}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
    >
      <circle cx="35" cy="35" r="35" fill="#FCD669" fillOpacity="0.6" />
      <path
        d="M46.5317 44.2701L36.7616 34.5L46.5317 24.73C47.1561 24.1054 47.1561 23.0929 46.5315 22.4685C45.9071 21.844 44.8945 21.844 44.27 22.4685L34.5 32.2385L24.73 22.4684C24.1055 21.8439 23.0929 21.8439 22.4684 22.4684C21.8439 23.0929 21.8439 24.1054 22.4684 24.73L32.2385 34.5L22.4684 44.2701C21.8439 44.8946 21.8439 45.9071 22.4684 46.5317C22.7807 46.8439 23.19 47 23.5991 47C24.0084 47 24.4177 46.8439 24.73 46.5317L34.5 36.7616L44.2701 46.5317C44.5824 46.8439 44.9916 47 45.4009 47C45.8102 47 46.2195 46.8439 46.5317 46.5317C47.1562 45.9071 47.1562 44.8946 46.5317 44.2701Z"
        fill="#C99100"
      />
    </svg>
  )
}

export default ModalMessageErrorIcon
